import { loginPages } from '@/(front-desk)/layout'
import axios from "axios"
import lscache from "lscache"

axios.interceptors.request.use(
    config => {
        if (process.env.API_BACKEND_HOST) {
            config.baseURL = process.env.API_BACKEND_HOST
        }
        return config
    },
    err => {
        return Promise.reject(err)
    },
)

axios.interceptors.response.use(
    res => {
        // console.log('axios interceptors: ', res)
        if (res.config.url === '/api/v1/accounts/login') {
            lscache.set('access', res.data.body.access)
            lscache.set('refresh', res.data.body.refresh)
        }
        return res
    },
    err => {
        // console.log('axios interceptors err: ', err.config.url)
        if (err?.config?.url === '/api/v1/accounts/token/refresh') {
            lscache.remove('access')
            lscache.remove('refresh')
            if (typeof window !== 'undefined' && window.location.pathname.includes('user') && !loginPages.includes(window.location.pathname)) {
                window.location.replace('/user/login')
            }
            return Promise.reject(err)
        }
        else {
            if (err.response?.status == 401) {
                const originalRequest = err.config
                const data = {
                    'refresh': lscache.get('refresh')
                }
                return axios.post('/api/v1/accounts/token/refresh', data)
                .then((res) => {
                    // console.log('refresh ✅: ', res)
                    lscache.set('access', res.data.body.access)
                    lscache.set('refresh', res.data.body.refresh)
                    originalRequest.headers.Authorization = `Bearer ${res.data.body.access}`
                    
                    return axios(originalRequest)
                })
                .catch((err) => {
                    // console.log('refresh error: ', err)
                    return Promise.reject(err)
                })
            }
            else {
                return Promise.reject(err)
            }
        }
    }
)